import { Component, effect, inject, OnInit } from '@angular/core';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { DataLayer } from '../../../models/data-layer';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DataLayerDataListComponent } from '../data-layer-data-list/data-layer-data-list.component';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-confirm-delete-data-layer',
  standalone: true,
  imports: [
    AlertComponent,
    AlertStyleDirective,
    ButtonModule,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    ScrollPanelModule,
    DataLayerDataListComponent,
  ],
  templateUrl: './confirm-delete-data-layer.component.html',
  styleUrl: './confirm-delete-data-layer.component.scss',
})
export class ConfirmDeleteDataLayerComponent implements OnInit {
  readonly layerStore = inject(DataLayerStore);
  readonly indicatorDataStore = inject(IndicatorDataStore);
  layerToDelete: DataLayer | null = null;
  layerHasData = false;
  constructor() {
    effect(() => {
      const layerState = getState(this.layerStore);
      this.layerToDelete = this.layerStore.selectedItem();
      this.checkForData();
    });
  }

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * It is used here to perform a check for data when the component is initialized.
   *
   * @return {void} No return value.
   */
  ngOnInit(): void {
    this.checkForData();
  }

  /**
   * Checks if the specified layer has associated data and updates the `layerHasData` property.
   * The method relies on `indicatorDataStore` to determine the presence of data for the given layer.
   *
   * @return {void} No return value.
   */
  checkForData(): void {
    if (!this.layerToDelete) return;
    this.layerHasData = this.indicatorDataStore.dataLayerHasData(
      this.layerToDelete._id
    );
  }
}
